<template>
  <a-card
    :bordered="false"
    :tab-list="[
    {key: 'IN_SELL',tab:$t('IN_SELL')|| '销售中'},
    {key:'OFF',tab:$t('OFF')||'下架'},
    {key:'PRESELL',tab:$t('PRESELL')||'预售'}
    ]"
    :active-tab-key="searchForm.data.status"
    @tabChange="key => onTabChange(key)"
  >
    <div>
      <div class="operation-wrap">
        <a-form-model
          layout="inline"
          label-position="top"
          :model="searchForm.data">
          <a-form-model-item label="系列">
            <a-input v-model="searchForm.data.seriesId" style="width: 150px" allowClear placeholder="请输入系列名"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('NAME')|| '商品名'">
            <a-input v-model="searchForm.data.name" style="width: 150px" allowClear placeholder="请输入商品名或编号"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('OPERATION') || '操作'">
            <a-space>
              <a-button
                type="primary"
                @click="getGoodsList">{{ $t('SEARCH') || '查询' }}
              </a-button>
              <a-button type="primary" @click="addGoods">
                {{ $t('ADD') || '添加' }}
              </a-button>
              <a-button type="primary" @click="multiPreSell">{{ $t('PRESELL') || '预售' }}</a-button>
              <a-button type="primary" @click="multiInSell">{{ $t('IN_SELL') || '上架' }}</a-button>
              <a-button type="danger" @click="multiOff">{{ $t('OFF') || '下架' }}</a-button>
              <a-button type="primary" @click="importGoodsExcel">{{ $t('IMPORT') || '导入' }}</a-button>
              <a-button type="primary" @click="exportExcel">{{ $t('EXPORT') || '导出' }}</a-button>
              <a-button
                type="danger"
                v-if="searchForm.data.status==='OFF'"
                @click="multiDelete">{{ $t('DELETE') || '删除' }}
              </a-button>

            </a-space>
          </a-form-model-item>
        </a-form-model>
      </div>
      <a-table
        :scroll="{ y: 'calc(100vh - 300px)' }"
        row-key="id"
        :row-selection="{ selectedRowKeys: table.sectionData,onChange:handleSelectionChange }"
        :data-source="table.data"
        :columns="table.columns"
        :pagination="false"
        :loading="table.loading"
        @selection-change="handleSelectionChange"
        @change="handleTableChange"
        style="width: 100%">
        <span slot="img" slot-scope="text, record">
           <a-avatar :size="80" shape="square" :src="record.coverPath"/>
        </span>
        <span slot="createAt" slot-scope="text, record">
          <time-formatter :time="record.createAt" format="YYYY-MM-DD"/>
        </span>
        <span slot="updateAt" slot-scope="text, record">
          <time-formatter :time="record.updateAt" format="YYYY-MM-DD"/>
        </span>
        <span slot="action" slot-scope="text, record">
<!--          <a-button type="link" @click="detailGoodsSize(record.id)">尺寸</a-button>-->
        <a-button type="link" @click="inspirationGoods(record.id)">{{ $t('INSPIRATION') || '灵感' }}</a-button>
          <a-button type="link" @click="editGoods(record.id)">{{ $t('EDIT') || '编辑' }}</a-button>
          <a-button
            type="link"
            v-if="table.sort.prop === 'sort'"
            @click="upGoods(record.id)">{{ $t('UP') || '上移' }}</a-button>
          <a-button
            type="link"
            v-if="table.sort.prop === 'sort'"
            @click="downGoods(record.id)">{{ $t('DOWN') || '下移' }}</a-button>
          <template v-if="searchForm.data.status==='OFF'">
          <a-divider type="vertical"/>
            <a-button type="link" @click="deleteGoods(record.id)">{{ $t('DELETE') || '删除' }}
          </a-button>

          </template>
        </span>
      </a-table>
      <a-pagination
        class="pagination-class"
        v-model="table.pagination.current"
        :total="table.pagination.total"
        show-size-changer
        :page-size="table.pagination.pageSize"
        :pageSizeOptions="['5','20','50','100']"
        @showSizeChange="handleSizeChange"
        @change="handleSizeChange">
        <template
          slot="buildOptionText"
          slot-scope="props">
          <span>{{ props.value }}条/页</span>
        </template>
      </a-pagination>
    </div>
    <a-drawer
      size="80%"
      title="SKU详情"
      v-model="skuForm.visible"
      append-to-body
    >
      <goods-sku-list
        v-if="skuForm.visible"
        :goods-id="skuForm.data.id"
        :goods-code="skuForm.data.code"
      />
    </a-drawer>
    <a-modal
      :footer="null"
      title="商品详情"
      append-to-body
      :close-on-click-modal="false"
      fullscreen
      v-model="form.visible">
      <goods-edit
        v-if="form.visible"
        :goods-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </goods-edit>
    </a-modal>
    <a-modal
      :footer="null"
      title="灵感"
      v-model="inspiration.visible">
      <goods-inspiration-edit
        v-if="inspiration.visible"
        :goods-id="inspiration.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </goods-inspiration-edit>
    </a-modal>
    <a-modal
      v-model="excelForm.visible"
      title="导入商品excel"
      @ok="closeModal"
      @cancel="onCancel">
      <a-form-model-item
        label="导入excel"
        required>
        <div :key="ImgKey">
          <excel-uploader/>
        </div>
      </a-form-model-item>
    </a-modal>
    <a-drawer
      title="商品尺寸"
      placement="right"
      :closable="false"
      width="60%"
      :destroyOnClose="true"
      @close="()=>{goodsForm.visible = false}"
      :visible="goodsForm.visible"
    >
      <goods-size-items
        v-if="goodsForm.visible"
        :goods-id="goodsForm.data.id">
      </goods-size-items>
    </a-drawer>
  </a-card>
</template>

<script>
import TimeFormatter from '@/components/TimeFormatter.vue';
import {
  _queryGoods,
  _offGoods,
  _deleteGoods,
  _upGoods,
  _downGoods,
  _multiUpdateGoods,
  _importGoods,
} from '@/api/goodsApi';
import {
  _queryGoodsCategories,
} from '@/api/goodsCategoryApi';
import {
  _queryGoodsSeriess,
} from '@/api/goodsSeriesApi';
import {
  _queryGoodsBrands,
} from '@/api/goodsBrandApi';
import GoodsEdit from './GoodsEdit.vue';
import GoodsInspirationEdit from './GoodsInspirationEdit.vue';
import GoodsSkuList from '../goodsSku/GoodsSkuList.vue';
import ExcelUploader from '@/components/ExcelUploader.vue';
import GoodsSizeItems from './GoodsSizeItems.vue';

async function getGoodsList() {
  this.table.loading = true;
  const { order } = this.table.sort;
  const result = await _queryGoods({
    seriesId: this.searchForm.data.seriesId,
    categoryId: this.searchForm.data.categoryId,
    status: this.searchForm.data.status,
    name: this.searchForm.data.name,
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction: order === 'ascend' ? 'ASC' : 'DESC',
  });
  this.table.data = result.content;
  this.table.pagination.total = result.totalElements;
  this.table.loading = false;
}

function editSku(row) {
  this.skuForm.data.id = row.id;
  this.skuForm.data.code = row.code;
  this.skuForm.visible = true;
}

function goodsImport() {
  this.goodsImportForm.visible = true;
}

function exportExcel() {
  const status = this.searchForm.data.status === 'ALL' ? '' : this.searchForm.data.status;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  window.open(`${process.env.VUE_APP_BASE_URL}/goods-export?status=${status}&sort=${this.table.sort.prop}`);
}

function addGoods() {
  this.$router.push('/goods-add');
}

function detailGoodsSize(goodsSeriesId) {
  this.goodsForm.data.id = goodsSeriesId;
  this.goodsForm.visible = true;
}

function handleSelectionChange(selectedRowKeys) {
  this.table.sectionData = selectedRowKeys;
}

function inspirationGoods(goodsId) {
  this.$router.push(`/goods-inspiration/${goodsId}`);
  // this.inspiration.data.id = null;
  // this.inspiration.visible = true;
}

function editGoods(goodsId) {
  this.$router.push(`/goods/${goodsId}`);
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  if (sorter.field) {
    this.table.sort = {
      prop: sorter.field,
      order: sorter.order,
    };
  }
  this.getGoodsList();
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getGoodsList();
}

async function upGoods(goodsId) {
  this.$confirm({
    title: '是否上移？',
    content: '',
    onOk: async () => {
      await _upGoods(goodsId);
      this.$message.success('上移成功');
      await this.getGoodsList();
    },
  });
}

function onCancel() {
  // this.$router.go(-1);
  this.getGoodsList();
}

async function downGoods(goodsId) {
  this.$confirm({
    title: '是否下移？',
    content: '',
    onOk: async () => {
      await _downGoods(goodsId);
      this.$message.success('下移成功');
      await this.getGoodsList();
    },
  });
}

// async function multiUploadGoods() {
//   if (this.goodsImportForm.numIds === '') {
//     // 如果为 '',则删除
//     return;
//   }
//   this.$confirm({
//     title: '是否将这些商品Id批量上架?',
//     content: '',
//     onOk: async () => {
//       // await _upGoods(goodsId)
//       this.uploadGoodsButtonLoading = true;
//       const result = await _uploadGoodsByHbxIds({
//         hbxGoodsIds: this.goodsImportForm.numIds
//       });
//       if (result) {
//         // 是否上传成功
//         this.$message.success('上架成功');
//         this.uploadGoodsButtonLoading = false;
//         this.goodsImportForm.visible = false;
//       }
//
//       this.getGoodsList();
//     },
//   });
// }

async function deleteGoods(goodsId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteGoods(goodsId);
      this.$message.success('删除成功');
      await this.getGoodsList();
    },
  });
}

async function offGoods(goodsId) {
  this.$confirm({
    title: '是否下架？',
    content: '',
    onOk: async () => {
      await _offGoods(goodsId);
      this.$message({
        type: 'success',
        message: '下架成功!',
      });
      await this.getGoodsList();
    },
  });
}

function handleSizeChange(current, pageSize) {
  this.table.pagination.current = current;
  this.table.pagination.pageSize = pageSize;
  this.getGoodsList();
}

function handlePageChange(val) {
  this.table.pagination.current = val;
  this.getGoodsList();
}

function multiInSell() {
  if (this.table.sectionData.length === 0) {
    return;
  }
  this.$confirm({
    title: '是否上架？',
    content: '',
    onOk: async () => {
      await _multiUpdateGoods(this.table.sectionData, 'IN_SELL');
      this.$message.success('设置成功');
      this.getGoodsList();
    },
  });
}

function multiPreSell() {
  if (this.table.sectionData.length === 0) {
    return;
  }
  this.$confirm({
    title: '是否预售？',
    content: '',
    onOk: async () => {
      await _multiUpdateGoods(this.table.sectionData, 'PRESELL');
      this.$message.success('设置成功');
      this.getGoodsList();
    },
  });
}

function closeImportForm() {
  this.goodsImportForm.visible = false;
  this.getGoodsList();
}

function multiOff() {
  if (this.table.sectionData.length === 0) {
    return;
  }
  this.$confirm({
    title: '是否下架？',
    content: '',
    onOk: async () => {
      await _multiUpdateGoods(this.table.sectionData, 'OFF');
      this.$message.success('设置成功');
      await this.getGoodsList();
    },
  });
}

function multiDelete() {
  if (this.table.sectionData.length === 0) {
    return;
  }
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _multiUpdateGoods(this.table.sectionData, 'REMOVE');
      this.$message.success('删除成功');
      this.getGoodsList();
    },
  });
}

const rowSelection = {
  onChange: (selectedRowKeys) => {
    this.table.sectionData = selectedRowKeys;
  },
};

function onTabChange(key) {
  this.searchForm.data.status = key;
  this.table.pagination.page = 1;
  this.getGoodsList();
}

function importGoodsExcel() {
  this.excelForm.visible = true;
}

function closeModal() {
  this.$confirm({
    title: '是否导入商品数据？',
    content: '',
    onOk: async () => {
      // 把上传解析后的数据加到数据库
      const goods = JSON.parse(window.localStorage.getItem('goods'));
      const goodsAttributeValue = JSON.parse(window.localStorage.getItem('goodsAttributeValue'));
      const goodsSKU = JSON.parse(window.localStorage.getItem('goodsSKU'));
      const goodsSkuAttributeValue = JSON.parse(window.localStorage.getItem('goodsSkuAttributeValue'));
      _importGoods({
        goods: goods,
        goodsAttributeValue: goodsAttributeValue,
        goodsSKU: goodsSKU,
        goodsSkuAttributeValue: goodsSkuAttributeValue,
      });
      this.$message.success('导入成功');
      await this.getGoodsList();
      this.excelForm.visible = false;
      location.reload();
    },
  });
}

const columns = [
  {
    title: '图片',
    scopedSlots: { customRender: 'img' },

  },
  {
    title: '商品名',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '编号',
    dataIndex: 'code',
    scopedSlots: { customRender: 'code' }
  },
  {
    title: '开始价格',
    dataIndex: 'startPrice',
  },
  {
    title: '结束价格',
    dataIndex: 'endPrice',
  },
  {
    title: '数量',
    dataIndex: 'quantity'
  },
  // {
  //   title: '是否限购',
  //   dataIndex: 'isLimited',
  // },
  {
    title: '操作',
    width: 300,
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  name: 'GoodsList',
  components: {
    TimeFormatter,
    GoodsSkuList,
    GoodsEdit,
    ExcelUploader,
    GoodsInspirationEdit,
    GoodsSizeItems,
  },
  data() {
    return {
      uploadUrl: `${process.env.VUE_APP_BASE_URL}/import`,
      ImgKey: '',
      rowSelection,
      uploadGoodsButtonLoading: false,
      // tabs: [
      //   {
      //   key: 'IN_SELL',
      //   tab: $t('IN_SELL')|| '销售中',
      //  },
      // {
      //   key: 'OFF',
      //   tab: '下架',
      // },
      // {
      //   key: 'PRESELL',
      //   tab: '预售',
      // },
      // ],
      category: {
        data: [],
      },
      series: {
        data: [],
      },
      brand: {
        data: [],
      },
      excelForm: {
        visible: false,
      },
      searchForm: {
        data: {
          status: 'IN_SELL',
          name: '',
          categoryId: '',
          brandId: '',
          seriesId: '',
          memberOnly: '',
          brandName: '',
        },
      },
      goodsImportForm: {
        visible: false,
        numIds: ''
      },
      goodsForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      skuForm: {
        data: {
          id: null,
          code: null,
        },
        visible: false,
      },
      inspiration: {
        data: {
          id: null,
        },
        visible: false,
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        columns,
        loading: false,
        data: [],
        sectionData: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descend',
        },
      },
    };
  },
  methods: {
    getGoodsList,
    deleteGoods,
    upGoods,
    downGoods,
    editGoods,
    offGoods,
    addGoods,
    closeForm,
    editSku,
    handleSizeChange,
    handlePageChange,
    handleSelectionChange,
    multiInSell,
    multiPreSell,
    multiOff,
    multiDelete,
    handleTableChange,
    onTabChange,
    goodsImport,
    closeImportForm,
    // multiUploadGoods,
    importGoodsExcel,
    closeModal,
    inspirationGoods,
    onCancel,
    detailGoodsSize,
    exportExcel,
  },
  async created() {
    const categoryResult = await _queryGoodsCategories({});
    this.category.data = categoryResult.content.filter(x => !x.parentId)
      .map(x => ({
        ...x,
        children: [...categoryResult.content.filter(c => c.parentId === x.id), {
          ...x,
          name: `${x.name}(All)`,
        }],
      }));
    const seriesResult = await _queryGoodsSeriess({});
    this.series.data = seriesResult.content;
    const brandResult = await _queryGoodsBrands({});
    this.brand.data = brandResult.content;
    await this.getGoodsList();
  },
  activated() {
    if (!this.$route.meta.isUseCache) {
      this.getGoodsList();
    }
  },
};
</script>

<style scoped>

.pagination-class {
  margin-top: 30px;
}

</style>
